import { createFileRoute } from "@tanstack/react-router";
import LocationPlan from "lib/components/builders/communities/plans/LocationPlan";
import withAuthentication from "../../../../../../../components/withAuthentication";

function PlanLibraryLocationPlan() {
  return <LocationPlan />;
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/location-plans/$location_plan_id/")({
  component: withAuthentication(PlanLibraryLocationPlan, {
    permissions: ["VIEW_COMMUNITY_PLANS"],
    resource: {
      resourceType: "community_plans",
      routeParamName: "location_plan_id",
    },
  }),
});
